import {
    TOP_BAR_LOAD,
    TOP_BAR_LOAD_FAIL,
    TOP_BAR_LOAD_SUCCESS,
} from './constants';

export const loadTopBar = () => ({
    type: TOP_BAR_LOAD,
    payload: null,
});

export const loadTopBarSuccess = (data) => ({
    type: TOP_BAR_LOAD_SUCCESS,
    payload: data,
});

export const loadTopBarFail = (data) => ({
    type: TOP_BAR_LOAD_FAIL,
    payload: data,
});
